<template>
  <div
    class="module-rules-block"
    :class="mainClasses"
    @click="modelValue = true"
  >
    <div class="module-rules-block__caption">
      <span>{{ title }}</span>
      <UISwitch v-if="!hideToggler" v-model="modelValue" :disabled :data-refid="`${camelCase(title)}RuleSwitcher`"/>
    </div>
    <div
      v-if="(modelValue || hideToggler) && $slots.default"
      class="module-rules-block__content"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { UISwitch } from '@ui/controllers'
import { camelCase } from 'lodash'

type Props = {
  title: string
  hideToggler?: boolean
  disabled?: boolean
}

defineProps<Props>()

const modelValue = defineModel<boolean>()

const mainClasses = computed(() => ({
  'module-rules-block--active': modelValue.value,
}))
</script>

<style>
.module-rules-block {
  @apply bg-gray-100 dark:bg-gray-900;
  @apply border border-transparent;
  @apply rounded-md;

  &:not(.module-rules-block--active) {
    @apply cursor-pointer;
  }

  &--active {
    @apply border-indigo-500;
    @apply dark:border-indigo-400 dark:border-opacity-50;
  }

  &__caption,
  &__content {
    @apply p-4;
  }

  &__caption {
    @apply flex items-center justify-between;
  }

  &__content {
    @apply flex flex-col;
    @apply gap-2;
    @apply pt-0;
  }
}
</style>
